import React from "react";

import { BetMessage, Proposition } from "../shared/interfaces";
import variables from "../styleVariables";
import CancelIcon from "../svg/CancelIcon";
import SuccessIcon from "../svg/SuccessIcon";

interface Props {
  firstBet: boolean;
  messages: Array<BetMessage>;
  suggestion: Proposition;
}

const BetMessages = ({ messages, firstBet, suggestion }: Props) => {
  const w: any = window;
  const handleNextClick = (prop: Proposition) => {
    w.gtag("event", "click suggested prop", {
      event_category: "navigation",
      event_label: prop.name,
      proposition: prop.name,
    });
  };

  return (
    <>
      <ul className="bet-messages">
        {firstBet && (
          <li className="bet-message bet-message--first-bet">
            <strong>Awesome!</strong> You just made your first bet. Cycling is
            about to get a whole lot more interesting for you. Good luck!
          </li>
        )}

        {messages.map((message, i) => (
          <li className={`bet-message bet-message--${message.status}`} key={i}>
            <span className="bet-message__icon">
              {message.status === "success" ? (
                <SuccessIcon
                  color="#ffffff"
                  foreground={variables.colorSecondary}
                />
              ) : (
                <CancelIcon color="#ffffff" foreground={variables.colorError} />
              )}
            </span>
            <span className="bet-message__text">{message.message}</span>
          </li>
        ))}
        {messages.filter((message) => message.status === "error").length ===
          0 &&
          suggestion && (
            <li className="best-message bet-message--suggestion">
              Next:{" "}
              <strong>
                <a
                  href={`/prop/${suggestion.slug}`}
                  onClick={() => handleNextClick(suggestion)}
                >
                  {suggestion.question}
                </a>
              </strong>
            </li>
          )}
      </ul>
    </>
  );
};

export default BetMessages;
